export const CHOICE_LETTERS = ["A", "B", "C", "D"] as const

export function questionCount(n: number) {
  return `${n} ${n === 1 ? "question" : "questions"}`
}

export function bestScoreLabel(score: number | null | undefined) {
  return score === null || score === undefined ? "Not taken yet" : `Best ${score}%`
}
